import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalComponent } from "../../global-component";
import { environment } from 'src/environments/environment';

const AUTH_API = GlobalComponent.AUTH_API;

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


@Injectable({ providedIn: 'root' })

/**
 * Auth-service Component
 */
export class AuthenticationService {

    user!: User;
    currentUserValue: any;

    private currentUserSubject: BehaviorSubject<User>;
    // public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')!));
        // this.currentUser = this.currentUserSubject.asObservable();
     }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, first_name: string, password: string) {
        // return getFirebaseBackend()!.registerUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });

        // Register Api
        return this.http.post(AUTH_API + 'signup', {
            email,
            first_name,
            password,
          }, httpOptions);
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    // login(email: string, password: string) {
    //     // return getFirebaseBackend()!.loginUser(email, password).then((response: any) => {
    //     //     const user = response;
    //     //     return user;
    //     // });

    //     return this.http.post(AUTH_API + 'signin', {
    //         email,
    //         password
    //       }, httpOptions);
    // }

  rolePrivelegesSubject = new BehaviorSubject<any>('');
  rolePrivelegesObservable$ = this.rolePrivelegesSubject.asObservable();

  curentRolePrivelegesSubject = new BehaviorSubject<any>('');
  currentRolePrivelegesObservable$ = this.curentRolePrivelegesSubject.asObservable();

  accessVerificationSubject = new BehaviorSubject<any>('');
  accessVerificationObservable$ = this.accessVerificationSubject.asObservable();

  importExportSubject = new BehaviorSubject<any>('');
  importExportObservable$ = this.importExportSubject.asObservable();

  accessRouterLinkSubject = new BehaviorSubject<any>('');
  accessRouterLinkObservable$ = this.accessRouterLinkSubject.asObservable();

  loggedInUserSubject = new BehaviorSubject<any>('');
  loggedInUserObservable$ = this.loggedInUserSubject.asObservable();

    login(data:any) {


      return this.http.post<any>(`${environment.baseurl}/auth/login`, data)
      .pipe(
        map(LData => {
          this.rolePrivelegesDataObservable(LData['response']['rolePriveleges']);
            localStorage.setItem('toast', 'true');
            localStorage.setItem('currentUser', JSON.stringify(LData.response));
            localStorage.setItem('token', LData.response.token);
            localStorage.setItem('Id', LData.response.id);
            localStorage.setItem('Id', LData.response.teamId);
            localStorage.setItem('token',LData.response.token);
            localStorage.setItem('name',LData.response.name)
            //   if (LData.status === 0) {
            //     localStorage.setItem('Id', LData.response.id);
            //     localStorage.setItem('token',LData.response.token);
            //     localStorage.setItem('name',LData.response.name);
            //     return {value: '0'};
            //   } else {
            //     return {value: '1' , Error: LData.Error};
            //   }
            })

          );

      }

    /**
     * Returns the current user
     */
    public currentUser(): any {
        return getFirebaseBackend()!.getAuthenticatedUser();
    }
    public rolePrivelegesDataObservable(data:any) {
      this.rolePrivelegesSubject.next(data);
    }

    public currentRolePrivelegesObservable(data:any) {
      this.curentRolePrivelegesSubject.next(data);

    }

    public accessVerificationObservable(data:any) {
      this.accessVerificationSubject.next(data);
    }

    public importExportObservable(data:any) {
      this.importExportSubject.next(data);
    }

    public accessRouterLinkObservable(data:any){
      this.accessRouterLinkSubject.next(data);
    }

    public loggedInUserObservable(data:any){
      this.loggedInUserSubject.next(data);
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        // return getFirebaseBackend()!.logout();
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
        this.currentUserSubject.next(null!);
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend()!.forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

}

